import React from "react";

export default function LoadingDataPlug() {
  return <div className="text-center text-base font-medium leading-7 text-gray-900 mt-8">Идет загрузка...</div>;
}
